import 'react-quill/dist/quill.snow.css';

import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import SelectableUnitUserComponent from '@components/SelectableUnitUserComponent';
import IPagination from '@interfaces/IPagination';
import IUnit from '@interfaces/IUnit';
import UnitService from '@services/Unit';
import UserService from '@services/UserService';
import { Button, Col, Modal } from 'antd';
import _ from 'lodash';
import findIndex from 'lodash/findIndex';
import React from 'react';

import FormBuilder from '../components/Form';
import Page from '../components/Page';
import Table from '../components/TableComponent';
import { UnitForm } from '../forms/Unit';
import NotificationComponent from '../helpers/_showNotifications';
import I18n from '../i18n';
import { IUser } from '../interfaces/IUser';
import AppContext from '../services/Context';
import styled from '../styled-components';

type PropType = { history: { replace: Function }; match: any; }

type StateType = {
  isLoading: boolean;
  iconLoading?: boolean;
  showRegisterUnitModal: boolean;
  tableData: IUnit[];
  unitAmount?: number;
  totalShowData?: number;
  curOffset?: string;
  disabled?: boolean;
  search: string;
  filter?: boolean;
  filteredTableData: IUnit[];
  editItem?: IUnit;
  serverResponse: any;

  // Users
  showUserSelectModal: boolean;
  selectedUnit: string,

  searchAvailableUsers: string;
  searchSavedUsers: string;

  loadingAvailableUsers: boolean;
  loadingSavedUsers: boolean;

  availableUsersData: IUser[];
  savedUsersData: any[];
  availableUsersAmount: number;
  savedUsersAmount: number;
  loadingMoreAvailableUsers: boolean;
  loadingMoreSavedUsers: boolean;
  availableUsersCurOffset?: string;
  savedUsersCurOffset?: string;
  // selectedAuditorObject?: AuditorInterface;
};

const tableColumns = [{
  title: 'table.units.name',
  dataIndex: 'name',
  key: 'name',
  class: 'name',
  width: '30%'
}, {
  title: 'table.units.code',
  dataIndex: 'code',
  key: 'code',
}, {
  title: 'table.units.linkUsers',
  dataIndex: 'linkUsers',
  key: 'linkUsers',
}, {
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
  width: '20%'
}];

const usersAvailableTableColumns = [
  {
    title: 'table.units.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.units.users.username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  }
];

const usersSavedTableColumns = [
  {
    title: 'table.units.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.units.users.username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  }
];
export default class Unit extends React.Component<PropType, StateType> {

  private _unitService: UnitService = new UnitService();
  private _usersService: UserService = new UserService();

  private SelectableUserUnitRef: any;
  private unitId: string;

  constructor(props: any) {
    super(props);
    this.unitId = ''
    this.SelectableUserUnitRef = React.createRef();
    this.loadMoreAvailableUsers = this.loadMoreAvailableUsers.bind(this);
    this.loadMoreSavedUsers = this.loadMoreSavedUsers.bind(this);
  }

  state = {
    isLoading: true,
    showRegisterUnitModal: false,
    iconLoading: false,
    tableData: [],
    unitAmount: 0,
    totalShowData: 5,
    filteredTableData: [],
    curOffset: undefined,
    disabled: undefined,
    search: '',
    filter: false,
    editItem: {
      id: undefined,
      name: '',
      code: '',
    },
    serverResponse: undefined,
    showUserSelectModal: false,
    selectedUnit: '',

    searchAvailableUsers: '',
    searchSavedUsers: '',

    loadingAvailableUsers: false,
    loadingSavedUsers: false,

    availableUsersData: [],
    savedUsersData: [],
    availableUsersAmount: 0,
    savedUsersAmount: 0,
    loadingMoreAvailableUsers: false,
    loadingMoreSavedUsers: false,
    availableUsersCurOffset: undefined,
    savedUsersCurOffset: undefined,
  };

  setLocale(locale: any) {
  }

  setUnit(unit: string) {
    this.unitId = unit;
  }

  componentDidMount() {
    this.getUnits(true);
  }

  toggleFormModal = () => {
    this.setState({
      showRegisterUnitModal: !this.state.showRegisterUnitModal,
      serverResponse: undefined,
      editItem: {
        id: undefined,
        name: '',
        code: '',
      },
    });
  }

  getUnits = async (reset: boolean) => {
    this.setState({ showRegisterUnitModal: false });
    if (reset) {
      this.setState({
        curOffset: undefined,
        showRegisterUnitModal: false,
        isLoading: true,
      });
    }
    try {
      const data: any = await this._unitService.listAll();
      const dataTableCreate: any = [];
      data.map(async (item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          code: item.code,
          // createdAt: item.createdAt,
        })
      })

      let newDataTableCreate: IUnit[] = [];
      if (!reset) {
        newDataTableCreate = this.state.tableData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
      this.setState({
        isLoading: false,
        iconLoading: false,
        unitAmount: data.count,
        tableData: newDataTableCreate,
        curOffset: data.offset
      });

    } catch (error) {
      console.warn(error);
      this.setState({
        isLoading: false,
      });
    }
  };

  openEditModal = (editItem: IUnit) => {
    this.setState({ editItem, showRegisterUnitModal: true });
  };

  onSubmit = async (input: any, actions: { setSubmitting: Function }) => {
    const { tableData } = this.state;

    try {
      let nextTableData: IUnit[] = [];
      if (!!input.id) {
        const response = await this._unitService.updateById(input.id, input);

        const targetIndex = findIndex(
          tableData,
          (item: IUnit) => item.id === response.id,
        );
        nextTableData = tableData;
        if (nextTableData[targetIndex]) {
          nextTableData[targetIndex] = Object.assign(nextTableData[targetIndex], response);
        }

      } else {
        const data: any = {
          name: input.name,
          code: input.code,
        }
        const response: any = await this._unitService.create(data);
        const createData = {
          id: response.id,
          name: response.name,
          code: response.code,

        }
        nextTableData = [createData, ...tableData];
      }

      this.setState({
        isLoading: false,
        showRegisterUnitModal: false,
        tableData: nextTableData,
      });
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.unitSuccess"));
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
    } finally {
      actions.setSubmitting(false);
    }
  };

  deleteUnit = async (id: string) => {
    try {
      const { tableData } = this.state;
      const nextTableData = tableData.filter((item: IUnit) => item.id !== id);
      this.setState({
        isLoading: false,
        tableData: nextTableData,
      });
      await this._unitService.deleteById(id);

    } catch (e) {
      console.error(e);
    }
  };

  loadMoreHistory = async (total: number) => {
    this.setState({
      iconLoading: true,
      totalShowData: total + 10
    })
    this.getUnits(false);
  }

  filterData = async (status: any) => {
    this.setState({
      isLoading: true
    })
    let filterTableData: IUnit[] = [];
    try {
      if (status === undefined) {
        this.setState({
          isLoading: false,
          disabled: status,
          filter: false,
        })
      } else {
        _.some(this.state.tableData, (o: any) => {
          if (o.disabled === status) {
            filterTableData.push(o)
          }
        })
        this.setState({
          isLoading: false,
          filteredTableData: filterTableData,
          disabled: status,
          filter: true
        })
      }

    }
    catch (err) {
      console.log(err)
    }
  }

  formatDataToTable(data: IUnit[]) {
    const nextDataTable: any = [];

    data.map(async (item: any) => {

      const linkUserInfo = (
        <Col >
          <a href="#" onClick={() => this.toggleUserSelectModal(item.id || '')}>{I18n.l('table.units.linkUsers')}</a>
        </Col>
      );

      nextDataTable.push({
        id: item.id,
        name: item.name,
        code: item.code,
        linkUsers: linkUserInfo,
        createdAt: item.createdAt,
      })
    })

    return nextDataTable;
  }

  searchData = async (event: any) => {
    const searchTableData: IUnit[] = [];
    const SearchValue = event === '' ? false : event.target.find.value;
    await this.setState({
      search: SearchValue,
      isLoading: true,
    })

    if (!SearchValue) {
      this.getUnits(true);
    }
    try {
      const patt = new RegExp(SearchValue, 'ig');
      _.some(this.state.tableData, (o: any) => {
        if (patt.test(o.name) || patt.test(o.code)) {
          searchTableData.push(o)
        }
      })
      await this.setState({
        isLoading: false,
        tableData: searchTableData
      })
    }
    catch (err) {
      console.log(err)
    }
  }

  //#region USER SELECT TO UNIT
  toggleUserSelectModal = async (unitId?: string, updateUnits?: Function) => {
    this.setState({ selectedUnit: unitId || '' })

    if (this.state.showUserSelectModal === false) {
      this.getAvailableUsers(true, true);
      this.getSavedUsers(true, true);
    }
    this.setState({
      showUserSelectModal: !this.state.showUserSelectModal,
      searchAvailableUsers: '',
      searchSavedUsers: '',
    });

    // if (updateUnits) {
    //     updateUnits();
    // }
  }

  onRemoveUser = async (userId: string) => {
    const { selectedUnit } = this.state;
    this.setLoadingSavedUserData(userId, true);

    const userObj = this.getUserSavedObject(userId);

    try {
      await this._usersService.unitRemove(userId, selectedUnit);
      this.setLoadingSavedUserData(userId, false);

      this.userRemoved(userId, userObj);
    } catch (e) {
      this.setLoadingSavedUserData(userId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  userRemoved = async (id: string, userRemoved: any) => {
    const { availableUsersData, savedUsersData } = this.state;

    const newAvailableData: any[] = [...availableUsersData];
    newAvailableData.push(userRemoved);

    const userIndexToRemove = savedUsersData.findIndex((item: any) => item.id === id);
    let nextSavedData = [...savedUsersData];
    nextSavedData.splice(userIndexToRemove, 1);

    this.setState({
      savedUsersData: nextSavedData,
      availableUsersData: newAvailableData,
      savedUsersAmount: (this.state.savedUsersAmount - 1),
      availableUsersAmount: (this.state.availableUsersAmount + 1)
    });
    if (this.state.savedUsersData.length === 0 && this.state.savedUsersAmount > 0) {
      this.getPagingRemoveUsers();
    }

  }

  onAddUser = async (userId: string) => {
    console.log("onAddUser");

    const { selectedUnit } = this.state;
    this.setLoadingAvailableUserData(userId, true);
    const userObj = this.getUserAvailableObject(userId);

    try {
      await this._usersService.unitAdd(userId, selectedUnit);
      this.setLoadingAvailableUserData(userId, false);
      this.userAdded(userId, userObj);

    } catch (e) {
      this.setLoadingAvailableUserData(userId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  userAdded = async (id: string, userToSave: any) => {
    const { availableUsersData, savedUsersData } = this.state;

    const newSaveData: any[] = [...savedUsersData];
    newSaveData.push(userToSave);

    const userIndexToRemove = availableUsersData.findIndex((item: any) => item.id === id);
    const nextAvailableData = [...availableUsersData];
    nextAvailableData.splice(userIndexToRemove, 1);

    this.SelectableUserUnitRef.current.saveAvailableUserDone();

    this.setState({
      availableUsersData: nextAvailableData,
      savedUsersData: newSaveData,
      savedUsersAmount: (this.state.savedUsersAmount + 1),
      availableUsersAmount: (this.state.availableUsersAmount - 1)
    });
    if (this.state.availableUsersData.length === 0 && this.state.availableUsersAmount > 0) {
      this.getPagingAddUsers();
    }
    // this.setAuditsToUser();
  }

  getUserAvailableObject(id: string) {
    const { availableUsersData } = this.state;
    let user = undefined;

    user = availableUsersData.find((item: any) => item.id === id);

    return user;
  }

  getUserSavedObject(id: string) {
    const { savedUsersData } = this.state;
    let user = undefined;

    user = savedUsersData.find((item: any) => item.id === id);

    return user;
  }

  setLoadingAvailableUserData = async (userId: string, loading: boolean) => {
    const { availableUsersData } = this.state;

    const user: any = availableUsersData.find((item: any) => {
      return item.id === userId;
    });
    const indexOf = availableUsersData.indexOf(user);

    const newUsersData: any[] = [...availableUsersData];
    newUsersData[indexOf].loading = loading;
    newUsersData[indexOf].disabled = loading;

    this.setState({ availableUsersData: newUsersData });
  }

  setLoadingSavedUserData = async (userId: string, loading: boolean) => {
    const { savedUsersData } = this.state;

    const user: any = savedUsersData.find((item: any) => {
      return item.id === userId;
    });
    const indexOf = savedUsersData.indexOf(user);

    const newUsersData: any[] = [...savedUsersData];
    newUsersData[indexOf].loading = loading;

    this.setState({ savedUsersData: newUsersData });
  }

  onSearchAvailableUsers = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    this.setState({ searchAvailableUsers: SearchValue });

    this.getAvailableUsers(true, true);
  }

  onSearchSavedUsers = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    this.setState({ searchSavedUsers: SearchValue });

    this.getSavedUsers(true, true);
  }

  getPagingAddUsers = async () => {
    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: '',
        notUnit: this.state.selectedUnit,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        disabled: this.state.disabled,
        limit: 6,
        offset: this.state.availableUsersCurOffset
      });

      const dataTableCreate: any[] = [];

      const loadingValue: boolean = false;

      data.items.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          username: item.username,
          loading: loadingValue,
          disabled: false,
        })
      });

      let newDataTableCreate: any[] = [];
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      this.setState({
        availableUsersData: newDataTableCreate,
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
        availableUsersCurOffset: data.offset,
      });

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };

  getPagingRemoveUsers = async () => {
    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: this.state.selectedUnit,
        to: undefined,
        from: undefined,
        search: this.state.searchSavedUsers,
        disabled: this.state.disabled,
        limit: 6,
        offset: this.state.savedUsersCurOffset
      });

      const dataTableCreate: any[] = [];

      data.items.map(async (item: any) => {
        dataTableCreate.push({
          name: item.name,
          username: item.username,
          id: item.id,
          loading: false,
        })
      });

      let newDataTableCreate: any[] = [];

      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      this.setState({
        savedUsersData: newDataTableCreate,
        loadingSavedUsers: false,
        loadingMoreSavedUsers: false,
        savedUsersCurOffset: data.offset,
      });


    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };


  getAvailableUsers = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    this.setState({
      loadingAvailableUsers: showLoading,
      loadingMoreAvailableUsers: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      this.setState({
        availableUsersData: [],
        availableUsersCurOffset: undefined,
      });
    }

    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: '',
        notUnit: this.state.selectedUnit,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        disabled: this.state.disabled,
        limit: 6,
        offset: this.state.availableUsersCurOffset
      });

      const dataTableCreate: any[] = [];

      const loadingValue: boolean = false;

      data.items.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          username: item.username,
          loading: loadingValue,
        })
      });

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.availableUsersData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      this.setState({
        availableUsersData: newDataTableCreate,
        loadingAvailableUsers: false,
        availableUsersAmount: data.count,
        loadingMoreAvailableUsers: false,
        availableUsersCurOffset: data.offset,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };

  getSavedUsers = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    this.setState({
      loadingSavedUsers: showLoading,
      loadingMoreSavedUsers: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      this.setState({
        savedUsersData: [],
        savedUsersCurOffset: undefined,
      });
    }

    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: this.state.selectedUnit,
        to: undefined,
        from: undefined,
        search: this.state.searchSavedUsers,
        disabled: this.state.disabled,
        limit: 6,
        offset: this.state.savedUsersCurOffset
      });

      const dataTableCreate: any[] = [];

      data.items.map(async (item: any) => {
        dataTableCreate.push({
          name: item.name,
          username: item.username,
          id: item.id,
          loading: false,
        })
      });

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.savedUsersData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      this.setState({
        savedUsersData: newDataTableCreate,
        loadingSavedUsers: false,
        savedUsersAmount: data.count,
        loadingMoreSavedUsers: false,
        savedUsersCurOffset: data.offset,
      });

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingSavedUsers: false,
        loadingMoreSavedUsers: false,
      });
    }
  };

  loadMoreAvailableUsers = () => {
    this.getAvailableUsers(false, false, true);
  }

  loadMoreSavedUsers = () => {
    this.getSavedUsers(false, false, true);
  }
  //#endregion

  render() {
    const {
      isLoading,
      showRegisterUnitModal,
      tableData,
      filteredTableData,
      editItem,
      unitAmount,
      serverResponse,
      totalShowData,
      filter,
      search,

      showUserSelectModal,
      loadingAvailableUsers,
      loadingSavedUsers,
      savedUsersData,
      availableUsersData,

      searchAvailableUsers,
      searchSavedUsers,
      availableUsersAmount,
      savedUsersAmount,
      loadingMoreAvailableUsers,
      loadingMoreSavedUsers
    } = this.state;

    if (!!isLoading) {
      return (
        <Page>
          <AppContext.Consumer>
            {({ locale, activeUnitId }) => (
              this.setLocale(locale),
              this.setUnit(activeUnitId),
              <span>{I18n.l('common.loadingTable')}</span>
            )}
          </AppContext.Consumer>
        </Page>
      );
    }

    return (
      <Page>
        <AppContext.Consumer>
          {({ updateUnits }) => (
            <Wrapper>
              <Toolbar>
                <ToolbarItem>
                  <RegisterBtnComponent
                    onClick={this.toggleFormModal}
                    buttonText={I18n.l('common.register') + " " + I18n.l('labels.unit')}
                  />
                </ToolbarItem>
                <ToolbarItem>
                  <SearchComponent
                    onSubmit={this.searchData}
                    placeholder='form.placeholders.unitsSearch'
                    defaultValue={search}
                    buttonText='form.buttons.search'
                  />
                </ToolbarItem>
              </Toolbar>

              {tableData.length > 0 && (
                <div className="goepik-component-tablesize">
                  <Table
                    columns={tableColumns}
                    data={filter ? this.formatDataToTable(filteredTableData) : this.formatDataToTable(tableData)}
                    onEdit={this.openEditModal}
                    // onDelete={this.deleteUnit}
                    noPagination={true}
                    showConfirmationModal={false}
                    hideDeleteButtonClass="hideDeleteButtonClass"
                  />
                </div>
              )}
              {unitAmount >= 10 && (
                <Button
                  className="loading-more"
                  type="primary"
                  loading={this.state.iconLoading}
                  onClick={() => this.loadMoreHistory(totalShowData)}
                  size='large'
                  ghost
                >
                  {I18n.l('common.seeMore')}
                </Button>
              )}

              {tableData.length === 0 && <p>{I18n.l('common.noResult')}</p>}
              {showRegisterUnitModal && (
                <Modal onCancel={this.toggleFormModal} visible={showRegisterUnitModal} footer={false}>
                  <ModalTitle>{I18n.l('form.titles.unitForm')}</ModalTitle>
                  <ModalContent>
                    <FormBuilder
                      settings={UnitForm}
                      onSubmit={this.onSubmit}
                      onCancel={this.toggleFormModal}
                      data={[
                        { name: 'id', value: editItem.id },
                        { name: 'name', value: editItem.name },
                        { name: 'code', value: editItem.code },
                      ]}
                    />
                  </ModalContent>
                </Modal>

              )}
              {showUserSelectModal && (
                <SelectableUnitUserComponent
                  title={
                    I18n.l('form.titles.linkUserToAudit')
                  }
                  showModal={showUserSelectModal}
                  onToggleFormModal={() => this.toggleUserSelectModal(undefined)}
                  serverResponse={serverResponse}
                  onItemRemoved={this.onRemoveUser}
                  onItemSelected={this.onAddUser}

                  loadingAvailableData={loadingAvailableUsers}
                  loadingSavedData={loadingSavedUsers}

                  usersAvailableData={availableUsersData}
                  usersSavedData={savedUsersData}
                  usersAvailableTableColumns={usersAvailableTableColumns}
                  usersSavedTableColums={usersSavedTableColumns}

                  onSearchAvailableUsers={this.onSearchAvailableUsers}
                  onSearchSavedUsers={this.onSearchSavedUsers}
                  searchAvailableUsersValue={searchAvailableUsers}
                  searchSavedUsersValue={searchSavedUsers}

                  showMoreAvailableData={this.state.availableUsersCurOffset != undefined && this.state.availableUsersCurOffset != ''}
                  showMoreSavedData={this.state.savedUsersCurOffset != undefined && this.state.savedUsersCurOffset != ''}
                  onLoadMoreAvailableData={this.loadMoreAvailableUsers}
                  onLoadMoreSavedData={this.loadMoreSavedUsers}
                  loadingMoreAvailableData={loadingMoreAvailableUsers}
                  loadingMoreSavedData={loadingMoreSavedUsers}

                  ref={this.SelectableUserUnitRef}
                />
              )}
            </Wrapper>
          )}
        </AppContext.Consumer>
      </Page>
    );
  }
}



const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    .loading-more {
        margin: 15px 0;
        padding: 0;
        border: 0;
        text-align: left
    }

    .filter-group {
        margin-bottom: 50px;
    }
    .hideDeleteButtonClass {
      display: none !important; 
    }
`;

const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;

const ToolbarItem = styled.div`
    flex: 1;

    &:first-of-type {
        flex: 0;
        margin-right: 15px;
    }
`;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

const ModalContent = styled.div`
  width: 100%;
`;
